import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles(theme => ({
	inputContainer: {
		flex: 1
	},
	associationIconContainer: {
		width: theme.spacing(8)
	},
	associationDescription: {
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[100]),
		fontWeight: "bold",
		fontSize: "15px",
		borderRadius: theme.spacing(0.5),
		padding: "18.5px 14px",
		border: `1px solid ${colors.gray[300]}`
	}
}))

export default useStyles
